import { Link, LinkTransactions } from '../../data/models/Links'
import { dateFormatter as NewDateFormatter, DateFormatTypes as NewDateFormatterType } from '../../util/util'
import { noExpiryString } from './../../screens/PaymentLinks/CreatePaymentLink/StateConstant'

const detailsTransactionsParser = (data: any) => {
  return JSON.parse(
    JSON.stringify(
      data?.map((details: any, index: number) => {
        return (
          LinkTransactions.create({
            id: `${index}`,
            createdAt: details?.createdAt ?? '',
            status: details?.status ?? '',
            extTranRefNo: details?.extTranRefNo ?? '',
            transactionRefNo: details?.transactionRefNo ?? '',
          }) ?? []
        )
      }),
    ),
  )
}
const checkPaymentLinkStatusParser = (data: any) => {
  const newLink = Link.create({
    id: data?.id ?? 'NA',
    jioLinkId: data?.jioLinkId ?? '',
    url: data?.url ?? '',
    // createdAt: NewDateFormatter(data?.createdAt ?? 'NA', NewDateFormatterType.DD_MMM_YYYY_HH_MM_AMPM),
    createdAt: data?.createdAt ?? 'NA',
    status: data?.linkStatus ?? '',
    amount: data?.amount ?? '',
    merchantLinkId: data?.merchantLinkId ?? '',
    linkExpiryAt: data?.linkExpiryAt
      ? NewDateFormatter(data?.linkExpiryAt, NewDateFormatterType.DD_MMM_YYYY_HH_MM_AMPM)
      : noExpiryString,
    invoice: data?.invoice ?? '',
    description: data?.description ?? '',
    pushSmsTo: data?.pushSmsTo ?? '',
    pushEmailTo: data?.pushEmailTo ?? '',
    merchantReturnUrl: data?.merchantReturnUrl ?? '',
    merchantCallBackUrl: data?.merchantCallBackUrl ?? '',
    customerName: data?.customerName ?? '',
    updatedAt: data?.updatedAt ?? '',
    cancelAt: data?.cancelAt ?? '',
    paidAt: NewDateFormatter(data?.paidAt, NewDateFormatterType.DD_MMM_YYYY_HH_MM_AMPM),
    transactions: data?.transactions?.length > 0 ? detailsTransactionsParser(data?.transactions) : [],
  })
  return { link: newLink }
}
export { checkPaymentLinkStatusParser }
